var map = {
	"./Agrártech.png": "01d1",
	"./Basic.svg": "29d0",
	"./Belvizelvezetes_ikon.png": "05b5",
	"./Elorejelzes_novenyvedelem_ikon.png": "57e4",
	"./Expert.svg": "c72f",
	"./Gepuzemeltetesi.png": "13ce",
	"./Gepuzemeltetesi_mukodtetesi_csomagok_ikon.png": "5972",
	"./PRO.svg": "a1f6",
	"./adatgyujtes_ikon.png": "832e",
	"./digitali_farm_ikon.png": "1242",
	"./dron_felvetelek_ikon.png": "5b66"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "25b0";